import { Injectable } from "@angular/core";
@Injectable()
export class UtcTimeZoneConverter {

    public date(str) {
        const date = new Date(str);
        return date.toUTCString();
      }
}
